import * as exElement from '../utils/element';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    //
    const elRange = exElement.create({
        merge: config,
        class: {
            add: 'range-custom',
        },
    });

    //
    const elRangeConnect = exElement.create({
        merge: config.rangeConnect,
        class: {
            add: 'range-connect',
        },
    });
    elRange.appendChild(elRangeConnect);

    //
    settings(elRange);

    // ------------------------------------------------------------------------

    //
    return elRange;
}

function settings(elRange: HTMLElement, config: Record<string, any> = {}): void {
    const elRangeFirst = exElement.create({
        merge: config.rangeFirst,
        class: {
            add: 'range-first',
        },
    });
    elRange.appendChild(elRangeFirst);

    const elRangeSecond = exElement.create({
        merge: config.rangeSecond,
        class: {
            add: 'range-second',
        },
    });
    elRange.appendChild(elRangeSecond);
}

// ----------------------------------------------------------------------------

export { create };
